import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import ModalPop from 'components/sales/modal/modal';
import { toast } from 'react-toastify';
import localization from 'assets/localization/localization';
import { deactivateDynamicContent } from 'services/api/dynamicContentsApi';
import './dynamicContentsForm.css';

const DeactivateDynamicContentPopup = ({
  show,
  onClose,
  content,
  onSuccess,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    if (!content?.id) return;

    setIsLoading(true);
    try {
      const res = await deactivateDynamicContent(content.id);
      toast.success(res?.message || localization.clientDashboardContentDeactivated);
      onClose();
      if (typeof onSuccess === 'function') onSuccess();
    } catch (err) {
      toast.error(err?.message || localization.clientDashboardContentDeactivateFailed);
    } finally {
      setIsLoading(false);
    }
  };

  const titleLabel = content?.title || `ID ${content?.id}`;

  return (
    <ModalPop
      title={localization.deactivateClientDashboardContent}
      show={show}
      handleModalHide={onClose}
      keyboard
      backdrop
    >
      <p className="mb-3">
        Are you sure you want to deactivate <strong>{titleLabel}</strong>? This cannot be undone
        from the dashboard.
      </p>
      <div className="dynamic-contents-popup-actions">
        <Button variant="secondary" onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleConfirm} disabled={isLoading}>
          {isLoading ? 'Deactivating...' : localization.deactivateClientDashboardContent}
        </Button>
      </div>
    </ModalPop>
  );
};

DeactivateDynamicContentPopup.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  content: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    title: PropTypes.string,
  }),
  onSuccess: PropTypes.func,
};

DeactivateDynamicContentPopup.defaultProps = {
  content: null,
  onSuccess: undefined,
};

export default DeactivateDynamicContentPopup;
